import React from 'react'
import { Tab } from 'semantic-ui-react'
import UserTable from './UserTable'
import TripTable from './TripTable'
import ReportTable from './ReportTable'
import ReviewTable from './ReviewTable'
import UserTripTable from "./UserTripTable";

function AdminTab(props) {
  const { handleInputChange } = props
  const { isUsersLoading, users, userUsernameSearch, handleDeleteUser, handleSearchUser, handlePaginationChange } = props
  const { isTripsLoading, trips, handleDeleteTrip, handleTripPaginationChange } = props
  const { isReportsLoading, reports, handleDeleteReport, handleReportPaginationChange } = props
  const { isReviewsLoading, reviews, handleDeleteReview, handleReviewPaginationChange } = props
  const { isUserTripsLoading, usertrips, handleDeleteUserTrip, handleUserTripPaginationChange } = props

  const panes = [
    {
      menuItem: { key: 'users', icon: 'users', content: 'Пользователи' },
      render: () => (
        <Tab.Pane loading={isUsersLoading}>
          <UserTable
            users={users}
            userUsernameSearch={userUsernameSearch}
            handleInputChange={handleInputChange}
            handleDeleteUser={handleDeleteUser}
            handleSearchUser={handleSearchUser}
            handlePaginationChange={handlePaginationChange}
          />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'trips', icon: 'travel', content: 'Поездки' },
      render: () => (
        <Tab.Pane loading={isTripsLoading}>
          <TripTable
            trips={trips}
            handleDeleteTrip={handleDeleteTrip}
            handleTripPaginationChange={handleTripPaginationChange}
          />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'usertrips', icon: 'bookmark', content: 'Заявки' },
      render: () => (
        <Tab.Pane loading={isUserTripsLoading}>
          <UserTripTable
            usertrips={usertrips}
            handleDeleteUserTrip={handleDeleteUserTrip}
            handleUserTripPaginationChange={handleUserTripPaginationChange}
          />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'reports', icon: 'content', content: 'Отчеты' },
      render: () => (
        <Tab.Pane loading={isReportsLoading}>
          <ReportTable
            reports={reports}
            handleDeleteReport={handleDeleteReport}
            handleReportPaginationChange={handleReportPaginationChange}
          />
        </Tab.Pane>
      )
    },
    {
      menuItem: { key: 'reviews', icon: 'envelope', content: 'Отзывы' },
      render: () => (
        <Tab.Pane loading={isReviewsLoading}>
          <ReviewTable
            reviews={reviews}
            handleDeleteReview={handleDeleteReview}
            handleReviewPaginationChange={handleReviewPaginationChange}
          />
        </Tab.Pane>
      )
    }

  ]

  return (
    <Tab menu={{ attached: 'top' }} panes={panes} />
  )
}

export default AdminTab
